import React from "react";

import {SearchContextProvider} from "../../../Components/GMS/Search/SearchContext";
import SearchManage from "../../../Components/GMS/Search/Manage";

function Search(props) {
    return (
        <React.Fragment>
            <SearchContextProvider>
                <SearchManage props={props}/>
            </SearchContextProvider>
        </React.Fragment>
    );
}

export default Search;
